import { useState, useCallback } from 'react';

/**
 * Ensure that setting one state automatically clears the other,
 * preventing both from being active simultaneously.
 *
 * @returns {Object}
 * @property {string} error
 * @property {string} message
 * @property {Function} setError
 * @property {Function} setMessage
 * @property {boolean} hasFeedback
 */
const useFeedback = () => {
  const [error, setErrorState] = useState(null);
  const [message, setMessageState] = useState(null);

  const setError = useCallback((newError) => {
    setMessageState(null);
    setErrorState(newError);
  }, []);

  const setMessage = useCallback((newMessage) => {
    setErrorState(null);
    setMessageState(newMessage);
  }, []);

  const hasFeedback = !!(error || message);

  return {
    error,
    message,
    setError,
    setMessage,
    hasFeedback,
  };
};

export default useFeedback;
